import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

import { reduxFormPropTypes, intlMessage } from 'constants/propTypes';
import { shouldShowError } from 'helpers/page-utils';
import Message from 'components/Message';

const RenderTextField = ({ className, disabled, input, maxLength, meta, placeholder, showErrorsWhenPristine }) => {
  const intl = useIntl();

  return (
    <div className="render-text-field">
      <textarea
        type="text"
        {...input}
        className={classNames({
          'render-text-field__textarea': true,
          'render-text-field__textarea--has-error': shouldShowError(meta, showErrorsWhenPristine),
          [className]: className,
        })}
        placeholder={placeholder ? intl.formatMessage(placeholder) : ''}
        disabled={disabled}
        maxLength={maxLength}
      />
      {shouldShowError(meta, showErrorsWhenPristine) && (
        <div className="render-text-field__error">
          <Message message={meta.error} />
        </div>
      )}
    </div>
  );
};

RenderTextField.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  input: reduxFormPropTypes.field.input,
  maxLength: PropTypes.number,
  meta: reduxFormPropTypes.field.meta,
  placeholder: intlMessage,
  showErrorsWhenPristine: PropTypes.bool,
};

export default RenderTextField;
